import { baseUCGet } from './baseUC';

export const baseBUCGet = ({ buildingId = '', userId = '', }) => {
    return {
        buildingId: buildingId,
        ...baseUCGet({ userId: userId, }),
    };
}